import React, { useState } from "react";
import axios from "axios";
import { CONTACT } from "./data";
import { ArrowRight } from "./icons";

const INTEREST_OPTIONS = [
  { label: "Fulfillment (storage, picking, delivery, cash collection)", value: "Fulfillment" },
  { label: "Software waitlist (EcomHQ, Backtracking, POS Bazaars, self-fulfillment)", value: "IMS" },
  { label: "Not sure yet", value: "Others" },
];

export function ContactPage() {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccessful, setIsSuccessful] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    setError("");
    const formData = new FormData(event.currentTarget);
    setIsLoading(true);
    axios
      .post("https://api.chainzsolutions.com/contact", {
        name: formData.get("name"),
        email: formData.get("email"),
        company: formData.get("company"),
        phone: formData.get("phone"),
        subject: formData.get("subject"),
        message: formData.get("message"),
      })
      .then((response) => {
        if (response.status === 200) setIsSuccessful(true);
      })
      .catch((reason) => {
        setError(reason?.message || "Something went wrong. Please try again.");
      })
      .finally(() => setIsLoading(false));
  };

  if (isSuccessful) {
    return (
      <div id="contact-page" style={{ padding: "80px clamp(16px, 4vw, 40px) 90px" }}>
        <div className="rv in card" style={{ maxWidth: 640, margin: "0 auto", padding: 48, textAlign: "center" }}>
          <div style={{ fontSize: "clamp(28px, 5vw, 40px)", fontWeight: 800, letterSpacing: "-0.01em" }}>Your message has been received</div>
          <div style={{ fontSize: 16, color: "#6b6470", marginTop: 14, lineHeight: 1.65 }}>
            Thank you for considering Chainz. We'll reach out soon to discuss how we can support your operations.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div id="contact-page" style={{ padding: "40px clamp(16px, 4vw, 40px) 90px" }} data-screen-label="Contact">
      <div style={{ maxWidth: 1180, margin: "0 auto" }}>
        <div className="rv in" style={{ textAlign: "center", maxWidth: 640, margin: "0 auto 54px" }}>
          <div style={{ fontSize: "clamp(30px, 6.5vw, 44px)", fontWeight: 800, letterSpacing: "-0.01em", lineHeight: 1.1 }}>
            Tell us about your brand
          </div>
          <div style={{ fontSize: 16, color: "#6b6470", marginTop: 14 }}>
            Whether you want us to run fulfillment end to end or join the waitlist for licensed software — we'll get back to you within a business day.
          </div>
        </div>

        <div
          className="rv contact-grid"
          style={{ display: "grid", gridTemplateColumns: "1.2fr 0.8fr", gap: 24, alignItems: "start", maxWidth: 980, margin: "0 auto" }}
        >
          <form className="card" style={{ padding: 36 }} onSubmit={handleSubmit}>
            <div className="cform-row" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
              <div>
                <label className="clabel" htmlFor="name">
                  Full name
                </label>
                <input className="cfield" id="name" name="name" type="text" placeholder="Your name" required />
              </div>
              <div>
                <label className="clabel" htmlFor="email">
                  Work email
                </label>
                <input className="cfield" id="email" name="email" type="email" placeholder="you@brand.com" required />
              </div>
            </div>
            <div className="cform-row" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginTop: 16 }}>
              <div>
                <label className="clabel" htmlFor="phone">
                  Phone
                </label>
                <input className="cfield" id="phone" name="phone" type="tel" placeholder="+20 10 000 0000" />
              </div>
              <div>
                <label className="clabel" htmlFor="company">
                  Brand / Company
                </label>
                <input className="cfield" id="company" name="company" type="text" placeholder="Your brand name" required />
              </div>
            </div>
            <div style={{ marginTop: 16 }}>
              <label className="clabel" htmlFor="subject">
                I'm interested in
              </label>
              <select className="cfield" id="subject" name="subject" defaultValue="Fulfillment">
                {INTEREST_OPTIONS.map((o) => (
                  <option key={o.value} value={o.value}>
                    {o.label}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ marginTop: 16 }}>
              <label className="clabel" htmlFor="message">
                Message
              </label>
              <textarea
                className="cfield"
                id="message"
                name="message"
                rows={4}
                placeholder="Tell us a bit about your order volume and what you need."
                required
              />
            </div>
            {error && (
              <div style={{ marginTop: 12, fontSize: 13.5, color: "#7D010C" }} role="alert">
                {error}
              </div>
            )}
            <button className="btn red" type="submit" disabled={isLoading} style={{ marginTop: 20, width: "100%", justifyContent: "center", padding: "14px 22px" }}>
              {isLoading ? "Sending…" : "Send Message"}
              {!isLoading && <ArrowRight size={14} />}
            </button>
          </form>

          <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
            <div className="card" style={{ padding: 28 }}>
              <div style={{ fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", fontWeight: 700, color: "#7D010C", marginBottom: 16 }}>
                Direct
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 14, fontSize: 14, color: "#2a242e" }}>
                <div>
                  <div className="clabel">Email</div>
                  <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
                </div>
                <div>
                  <div className="clabel">Phone</div>
                  <a href={`tel:${CONTACT.phoneTel}`}>{CONTACT.phone}</a>
                </div>
                <div>
                  <div className="clabel">Warehouse</div>
                  {CONTACT.address}
                </div>
              </div>
            </div>
            <div
              className="card"
              style={{
                padding: 28,
                background: "linear-gradient(150deg, #14100f, #050506)",
                borderColor: "rgba(255,255,255,0.08)",
                color: "#fff",
              }}
            >
              <div style={{ fontSize: 17, fontWeight: 700 }}>Prefer WhatsApp?</div>
              <div style={{ fontSize: 13.5, color: "rgba(255,255,255,0.7)", marginTop: 8, lineHeight: 1.6 }}>
                Message us directly and we'll pick it up during business hours.
              </div>
              <a className="btn ghost-lite" href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" style={{ marginTop: 16 }}>
                Message us on WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
